import { Linkedin, MapPin, Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { PHONE_TEL } from "./Header";

const PORTRAIT_IMG = "/james-pearson.png";

const CREDENTIALS = [
  "40+ years across Defence, Government & mining",
  "Complex program & operations leadership",
  "In-Country Value strategy and delivery",
  "Local and overseas engagements",
];

export default function AboutJames() {
  return (
    <section id="about" data-testid="about-james-section" className="py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid grid-cols-12 gap-10 md:gap-14 items-center">
        <Reveal className="col-span-12 md:col-span-5">
          <div className="relative">
            <div className="absolute -inset-3 border border-teal-400/30 translate-x-4 translate-y-4 pointer-events-none" aria-hidden="true" />
            <img
              src={PORTRAIT_IMG}
              alt="James Pearson, Principal of Coastal Logistics Solutions"
              data-testid="about-james-portrait"
              className="relative w-full aspect-[5/4] object-cover object-center border border-white/10"
            />
          </div>
        </Reveal>

        <div className="col-span-12 md:col-span-7 md:pl-4">
          <Reveal>
            <p className="text-xs md:text-sm tracking-[0.25em] uppercase text-teal-400 font-medium">
              About
            </p>
            <h2 className="mt-4 font-display text-3xl md:text-5xl tracking-tight leading-tight text-slate-50">
              James Pearson
            </h2>
            <p className="mt-2 font-display italic text-lg md:text-xl text-slate-400">
              Principal, Coastal Logistics Solutions Pty Ltd
            </p>
          </Reveal>
          <Reveal delay={0.08}>
            <p className="mt-7 text-base md:text-lg leading-relaxed text-slate-300 max-w-2xl">
              James has spent more than four decades leading supply chain, logistics and commercial
              outcomes across Defence, Government, mining and complex major programs — in Australia
              and overseas. Coastal Logistics Solutions is the vehicle for that experience: a senior,
              independent resource organisations engage when the problem is defined, the stakes are
              real, and the answer can't wait for a recruitment cycle.
            </p>
          </Reveal>
          <Reveal delay={0.14}>
            <ul className="mt-8 grid sm:grid-cols-2 gap-x-8 gap-y-3 max-w-2xl" data-testid="about-james-credentials">
              {CREDENTIALS.map((c) => (
                <li key={c} className="flex items-start gap-3 text-sm md:text-base text-slate-300">
                  <span className="mt-2 h-1.5 w-1.5 rotate-45 bg-teal-400 shrink-0" aria-hidden="true" />
                  {c}
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="mt-9 flex flex-wrap items-center gap-5">
              <a
                href={PHONE_TEL}
                data-testid="about-call-james-btn"
                className="inline-flex items-center gap-2.5 rounded-full bg-teal-400 px-6 py-3 text-sm font-semibold text-[#02060D] hover:bg-teal-300 hover:shadow-[0_0_28px_rgba(45,212,191,0.35)] transition-[background-color,box-shadow] duration-300"
              >
                <Phone className="h-4 w-4" />
                Call James
              </a>
              <a
                href="https://au.linkedin.com/in/james-pearson-82169932"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="about-linkedin-btn"
                aria-label="James Pearson on LinkedIn"
                className="inline-flex items-center gap-2.5 rounded-full border border-white/25 px-6 py-3 text-sm font-medium text-slate-100 hover:border-teal-300 hover:text-teal-300 transition-colors duration-300"
              >
                <Linkedin className="h-4 w-4" />
                LinkedIn
              </a>
              <p className="inline-flex items-center gap-2 text-sm text-slate-400">
                <MapPin className="h-4 w-4 text-teal-400" />
                Point Frederick, NSW — working locally & overseas
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
